// extracted by mini-css-extract-plugin
export var callCard = "_mn-0";
export var callMessageButton = "_mn-1";
export var helpIcon = "_mn-3";
export var helpIconContainer = "_mn-4";
export var verticalDivider = "_mn-2";